<div class="grid-x honeypot">
  <h2 class="cell text-center" [innerHTML]="textkeyPrefix + '.headline' + (noPrograms ? '.none' : '') | translate"></h2>
  @for (teaser of countTeaserImages; track teaser) {
    <div class="cell small-12 medium-{{mediumBreakpoint}} large-{{largeBreakpoint}} teaser" [class.alternative]="noPrograms">
      <app-advisor-image [path]="'/foc/foc-teaser-' + teaser + '.svg'"></app-advisor-image>
      <p [innerHTML]="textkeyPrefix + '.teaser.' + (noPrograms ? 'none' : teaser) | translate"></p>
    </div>
  }
  <div class="cell text-center medium-8 large-7">
    <button class="button inline-arrow-right medium-8 large-7" (click)="clickTarget !== null ? onClickToLeadModule() : null"
      [class.signal-cta]="internalPortal" [class.primary]="!internalPortal"
      [innerHTML]="textkeyPrefix + '.button' + (noPrograms ? '.none' : '') | translate"
    [attr.aria-controls]="clickTarget !== null ? clickTarget : null"></button>
    <p [innerHTML]="textkeyPrefix + '.userinfo' | translate"></p>
  </div>
</div>
